import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="bar-fields"
export default class extends Controller {
  static targets = ["container", "template", "legend"];
  static values = { nextIndex: Number, labelPrefix: {type: String, default: "Bar"} };

  connect() {
    this.renumber();
  }

  addBar() {
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", this.nextIndexValue);
    this.containerTarget.insertAdjacentHTML("beforeend", html);
    this.nextIndexValue++;
    this.renumber();
  }

  removeBar(event) {
    event.target.closest(".bar-fields-row").remove();
    this.renumber();
  }

  renumber() {
    this.legendTargets.forEach((legend, index) => {
      legend.textContent = `${this.labelPrefixValue} ${index + 1}`;
    });
  }
}
